import { render, staticRenderFns } from "./XiaoQQueryEmbed.vue?vue&type=template&id=367688c2&scoped=true&"
import script from "./XiaoQQueryEmbed.vue?vue&type=script&lang=js&"
export * from "./XiaoQQueryEmbed.vue?vue&type=script&lang=js&"
import style0 from "./XiaoQQueryEmbed.vue?vue&type=style&index=0&id=367688c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367688c2",
  null
  
)

export default component.exports